/**
 * Chunks an array into sub-arrays of a given size
 *
 * @param arr<T>
 * @param size Number of items per sub-array
 * @returns arr<arr<T>>
 */
export function chunk<T>(arr: T[], size: number): T[][] {
	const results = [];
	let index = 0;
	while (index < arr.length) {
		results.push(arr.slice(index, size + index));
		index += size;
	}
	return results;
}

export function unique<T>(arr: Array<T>): Array<T> {
	return Array.from(new Set(arr));
}

// From https://stackoverflow.com/questions/31973278/iterate-an-array-as-a-pair-current-next-in-javascript
export function* slidingWindow<T>(windowSize: number, array: T[]): Generator<T[]> {
	const maxBaseIndex = array.length - windowSize;
	for (let baseIndex = 0; baseIndex <= maxBaseIndex; baseIndex += 1) {
		yield array.slice(baseIndex, baseIndex + windowSize);
	}
}
